var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('app-search',{attrs:{"search":_vm.search},on:{"onSearch":_vm.handleSearch,"onSelect":_vm.handleSelect,"onSubmit":_vm.handleSubmit,"onClear":_vm.handleClear}}),_c(_vm.getComponentByRole,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }